exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".si-quotes-view {\n  height: calc(100vh - 240px);\n}\n", ""]);
